import React from 'react';
import { CountryAlpha3Code } from '@cmctechnology/webinvest-constants';
import { DropdownToggle } from '../Dropdown/DropdownToggle';
import { IconButton, IconButtonSize } from '../../components/IconButton/IconButton';
import { MATERIAL_ICONS } from '../../components/Icon/icons';
import { BUTTON_MODES, BUTTON_VARIANTS } from '../../components/Button/buttonVariants';
import { SIZES } from '../../fundamentals/sizes/sizes';
import { CountryFlag, generateFlagUrl, ICountryFlagProps } from '../../components/CountryFlag/CountryFlag';
import styled from 'styled-components';
import { BASE_STATE_KEYS } from '../../fundamentals/colours/colourInterfaces';
import { setAvatarEffectStyle } from '../../components/Avatar/Avatar';
import { IButtonProps, useButtonSelectorCss } from '../../components/Button/Button';
import { ButtonRoot } from '../../components/Button/ButtonRoot';
import { useTestId } from '../../hooks/useTestId/useTestId';
import { BaseDiv } from '../../common/BaseElements';

export type CountryDropdownToggleSize = typeof SIZES.X_SMALL | typeof SIZES.SMALL | typeof SIZES.MEDIUM | typeof SIZES.LARGE | typeof SIZES.X_LARGE;

export interface ICountryDropdownToggleProps {
  code: CountryAlpha3Code;
  size?: CountryDropdownToggleSize;
}

const Container = styled(BaseDiv)<Pick<IButtonProps, 'variant' | 'mode'> & Pick<ICountryFlagProps, 'img'>>`
  cursor: pointer;
  &:hover {
    ${ButtonRoot} {
      ${useButtonSelectorCss(BASE_STATE_KEYS.HOVER)};
    }
    ${CountryFlag} {
      ${setAvatarEffectStyle(BASE_STATE_KEYS.HOVER)};
    }
  }

  &:active {
    ${ButtonRoot} {
      ${useButtonSelectorCss(BASE_STATE_KEYS.ACTIVE)};
    }
    ${CountryFlag} {
      ${setAvatarEffectStyle(BASE_STATE_KEYS.ACTIVE)};
    }
  }
`;

const toggleIconSize: Record<CountryDropdownToggleSize, IconButtonSize> = {
  [SIZES.X_SMALL]: SIZES.XX_SMALL,
  [SIZES.SMALL]: SIZES.XX_SMALL,
  [SIZES.MEDIUM]: SIZES.X_SMALL,
  [SIZES.LARGE]: SIZES.SMALL,
  [SIZES.X_LARGE]: SIZES.MEDIUM
};

export const CountryDropdownToggle: React.FC<ICountryDropdownToggleProps> = ({ code, size, ...rest }) => {
  const { generateTestId } = useTestId(rest, 'CountryDropdownToggle');
  return (
    <DropdownToggle>
      <Container variant={BUTTON_VARIANTS.SECONDARY} mode={BUTTON_MODES.MINIMAL} img={generateFlagUrl({ code }).img} {...generateTestId()}>
        <CountryFlag code={code} size={size || SIZES.SMALL} gutterRight={8} onClick={/* istanbul ignore next */ () => {}} />
        <IconButton
          icon={MATERIAL_ICONS.ExpandMore}
          variant={BUTTON_VARIANTS.SECONDARY}
          size={toggleIconSize[size || SIZES.SMALL]}
          mode={BUTTON_MODES.MINIMAL}
        />
      </Container>
    </DropdownToggle>
  );
};
